import React, { useCallback, useRef } from "react";
import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { FeedbackItem } from "../../Models/FeedbackItem";
import { useIndexContext } from "./providers/Index";
import { useListProps } from "./utilities/list";
import ListItem from "./ListItem";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const Index: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const { id } = useIndexContext();
  const listProps = useListProps();

  const renderItem = useCallback((item: FeedbackItem, index: number) => {
    return <ListItem listRef={listRef} item={item} index={index} />;
  }, []);

  return (
    <>
      <AnyListProvider path={listProps.path} parentId={id}>
        <AnyList
          renderItem={renderItem}
          pagination={listProps.pagination}
          actionBar={listProps.actionBar}
          selectRowsEnabled={listProps.selectRowsEnabled}
        />
      </AnyListProvider>
      <div className="d-flex mt-3"></div>
    </>
  );
};

export default Index;
